import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Link,
    Card,
    Stack,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    FormControlLabel,
    Container,
    Typography,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Grid,
    Box,
    Button
} from '@mui/material';
import { ListHead, ListToolbar, MoreMenu } from '../../components/_dashboard/car';
import { LoadingButton } from '@mui/lab';
import Scrollbar from '../../components/Scrollbar';
import { fetchAllAgreements, printAgreement, searchAgreements } from '../../actions/agreementAction';
import _ from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';
import CloudDownload from "@material-ui/icons/CloudDownload";
import Edit from "@material-ui/icons/Edit";
import DeleteOutlined from "@material-ui/icons/DeleteOutlined";
import ModalCompoennt from '../Portal/ModalCompoennt';
import UpdateAgreement from './UpdateAgreement';
import DeleteAgreement from './DeleteAgreement';
import CreateInstallmentPlan from '../installments/CreateInstallmentPlan';
import Pagination from '@mui/material/Pagination';
import SearchIcon from '@mui/icons-material/Search';
import ResetIcon from '@mui/icons-material/Restore';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

const TABLE_HEAD = [
    { id: 'agreement_id', label: 'Agreement ID', alignRight: false },
    { id: 'car_name', label: 'Car Name', alignRight: false },
    { id: 'buyer_name', label: 'Buyer Name', alignRight: false },
    { id: 'description', label: 'Description', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    { id: 'actions', label: 'Actions', alignRight: false },
    { id: '', label: '', alignRight: false },
];

function AgreementList(props) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [filterId, setFilterId] = useState('');
    const [filterCarName, setFilterCarName] = useState('');
    const [filterBuyerName, setFilterBuyerName] = useState('');
    const [page, setPage] = useState(1);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [agreementObj, setAgreementObj] = useState({});
    const [openInstallment, setOpenInstallment] = useState(false);

    useEffect(() => {
        setIsLoading(false);
    }, [props.alerts]);

    useEffect(() => {
        props.fetchAllAgreements(page);
    }, []);

    const handleUpdateClick = (a) => {
        setOpenUpdate(true);
        setAgreementObj(a);
    }

    const handleAddClick = () => {
        setAddOpen(true);
    }
    
    const closeButton = () => {
        setOpenUpdate(false);
        setOpenDelete(false);
        setOpenInstallment(false);
        setAgreementObj({});
    }

    const handleDownloadClick = (a) => {
        const values = {};
        values.agreement_id = a.id;
        return props.printAgreement(values);
    }

    const hanldeDeleteClick = (a) => {
        setOpenDelete(true);
        setAgreementObj(a);
    }

    const hanldeInstallmentClick = (a) => {
        setOpenInstallment(true);
        setAgreementObj(a);
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        props.fetchAllAgreements(newPage);
    }

    const handleFilterById = (event) => {
        setFilterId(event.target.value);
    };
    
    const handleFilterByCarName = (event) => {
        setFilterCarName(event.target.value);
    };
    
    const handleFilterByBuyerName = (event) => {
        setFilterBuyerName(event.target.value);
    };

    const searchRecord = () => {
        if(filterId != '' || filterCarName != '' || filterBuyerName != '') {
            const values = {
                id: filterId,
                motor: filterCarName,
                buyer_name: filterBuyerName,
            };
            props.searchAgreements(values);
        } else {
            console.log('insert record');
        }
    }
    
    const handleReset = () => {
        setFilterId('');
        setFilterBuyerName('');
        setFilterCarName('');
        props.fetchAllAgreements(page);
    }

    const renderAgreementList = () => {
        if(!_.isEmpty(props.agreements.data)) {
            var agreements = props.agreements.data;
            var f_agreements = _.orderBy(agreements, ['id'], ['desc']);
            return f_agreements.map((a) => {
                return (
                    <TableRow
                        hover
                        tabIndex={-1}
                    >
                        <TableCell align="left" style={{padding:"10px"}}>{a.id}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{a.car.motor}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{a.car.buyer_name}</TableCell>
                        <TableCell alig n="left" style={{padding:"10px"}}>{a.description}</TableCell>
                        <TableCell align="left" style={{padding:"10px"}}>{a.status == 1 ? "Active" : 'Cancled' }</TableCell>
                        <TableCell>
                            <IconButton sx={{float:"left",padding:"0px", color:"#c29136"}} onClick={() => handleDownloadClick(a)}>
                                <CloudDownload />
                            </IconButton>
                            <IconButton sx={{float:"left",padding:"0px", color:"red"}} onClick={() => hanldeDeleteClick(a)}>
                                <DeleteOutlined />
                            </IconButton>
                        </TableCell>
                        <TableCell align="left">
                            <MoreMenu isAgreementMenu={true} isCarMenu={false} agreement={a} hanldeInstallmentClick={() => hanldeInstallmentClick(a)} />
                        </TableCell>
                    </TableRow>
                );
            })
        } else {
            return <TableRow>
                <TableCell colSpan={6}>No Agreement Exist</TableCell>
            </TableRow>
        }
    }

    return (
        <Page title="Agreement List">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Grid>
                    <Typography variant="h4" gutterBottom>
                        Agreement List 
                    </Typography>
                </Grid>
            </Stack>
            <Card>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 800 }}>
                        <Table>
                            <ListHead
                                headLabel={TABLE_HEAD}
                                rowCount={props.agreements.length}
                            />
                            <TableRow>
                                <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                                    <ListToolbar
                                    // numSelected={selected.length}
                                    filter={filterId}
                                    onFilter={handleFilterById}
                                    filterPlaceHolder= "Agreement Id..."
                                    />
                                </TableCell>
                                <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                                    <ListToolbar
                                    // numSelected={selected.length}
                                    filter={filterCarName}
                                    onFilter={handleFilterByCarName}
                                    filterPlaceHolder= "Car Name..."
                                    />
                                </TableCell>
                                <TableCell align="left" style={{padding:"0px"}} colSpan={1}>
                                    <ListToolbar
                                    // numSelected={selected.length}
                                    filter={filterBuyerName}
                                    onFilter={handleFilterByBuyerName}
                                    filterPlaceHolder= "Buyer Name..."
                                    />
                                </TableCell>
                                <TableCell colSpan={1}>
                                    <Button variant="contained" onClick={searchRecord} sx={{backgroundColor:"#c29136"}} startIcon={<SearchIcon />}>Search</Button>
                                </TableCell>
                                <TableCell colSpan={3}>
                                    <Button variant="contained" onClick={handleReset} sx={{backgroundColor:"red"}} startIcon={<ResetIcon />} >Reset</Button>
                                </TableCell>
                            </TableRow>
                            <TableBody>
                                {renderAgreementList()}
                            </TableBody>
                        </Table>
                        <Pagination sx={{float:"right",marginTop:"10px",marginBottom:"10px"}} page={page} count={props.agreements.paginate.last_page} variant="outlined" color="primary" onChange={handlePageChange} />
                    </TableContainer>
                </Scrollbar>
            </Card>
            {
                openUpdate && 
                <ModalCompoennt open={openUpdate} onClose={closeButton} title="Update Agreement" width="lg">
                    <UpdateAgreement onDismis={closeButton} agreement={agreementObj} />
                </ModalCompoennt>
            }
            {
                openDelete &&
                <ModalCompoennt open={openDelete} onClose={closeButton} title="Delete" width="xs" color="red">
                    <DeleteAgreement agreement={agreementObj} onDismis={closeButton} />
                </ModalCompoennt>
            }
            {
                openInstallment && 
                <ModalCompoennt open={openInstallment} onClose={closeButton} title="Create Installment" width="lg">
                    <CreateInstallmentPlan agreement={agreementObj} onDismis={closeButton} />
                </ModalCompoennt>
            }
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
        agreements: state.agreements,
    }
}

export default connect(mapStateToProps, { fetchAllAgreements, printAgreement, searchAgreements })(AgreementList);

